// Tracking-Script-Injektion + Consent-Mode-v2-Sync.
// index.html legt nur die Stubs an (denied defaults, fbq('consent','revoke')), lädt aber
// weder GTM noch Meta Pixel. Diese Utilities laden die Skripte erst nach Einwilligung,
// schalten die Signale frei und injizieren restaurant-spezifische Zusatz-Pixel.
const once = (flag, fn) => { if (window[flag]) return; window[flag] = true; fn(); };
const ladeGtm = () => { try { window.__ygLadeGtm?.(); } catch (_e) { /* ignore */ } };
const ladeMeta = () => { try { window.__ygLadeMeta?.(); } catch (_e) { /* ignore */ } };

// Erlaubt Restaurant-eigene GTM/Meta-Pixel, wenn abweichend von den Plattform-IDs.
// Für die Plattform selbst (yourgastro.de) reicht das im index.html eingebettete Setup.
export function injectStatistics(cfg) {
  // Consent-Mode v2: Storage-Signale freischalten – GTM-Tags mit `wait_for_update`
  // reagieren automatisch.
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: "granted",
      functionality_storage: "granted",
      security_storage: "granted",
    });
  }
  ladeGtm();
  // Zusätzliches, restaurant-spezifisches GTM (falls Restaurant eine eigene Property nutzt).
  const extraGtm = cfg?.gtm_id;
  if (extraGtm && extraGtm !== "GTM-TKW9ZGLT") once("_ygGtmExtra", () => {
    const s = document.createElement("script");
    s.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${extraGtm}');`;
    document.head.appendChild(s);
  });
}

export function injectMarketing(cfg) {
  // Meta-Pixel-Consent freischalten (Signal an bereits geladenes fbq).
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    try { window.fbq("consent", "grant"); } catch (_e) { /* ignore */ }
  }
  // Werbe-Signale in Consent-Mode v2 freischalten.
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
      personalization_storage: "granted",
    });
  }
  // Werbe-Tags im Tag Manager brauchen GTM, das Meta Pixel sein eigenes Skript
  ladeGtm();
  ladeMeta();
  // Restaurant-spezifisches Meta-Pixel (zusätzlich zur Plattform-ID).
  const extraMeta = cfg?.meta_pixel;
  if (extraMeta && extraMeta !== "1362919941839718") once("_ygMetaExtra", () => {
    if (typeof window.fbq === "function") {
      try { window.fbq("init", extraMeta); window.fbq("track", "PageView"); } catch (_e) { /* ignore */ }
    }
  });
  if (cfg?.tiktok_pixel) once("_ygTiktok", () => {
    const s = document.createElement("script");
    s.innerHTML = `!function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"];ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};ttq.load('${cfg.tiktok_pixel}');ttq.page();}(window,document,'ttq');`;
    document.head.appendChild(s);
  });
  if (cfg?.pinterest_tag) once("_ygPin", () => {
    const s = document.createElement("script");
    s.innerHTML = `!function(e){if(!window.pintrk){window.pintrk=function(){window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var n=window.pintrk;n.queue=[],n.version="3.0";var t=document.createElement("script");t.async=!0,t.src=e;var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");pintrk('load','${cfg.pinterest_tag}');pintrk('page');`;
    document.head.appendChild(s);
  });
}

const CY_HOSTS = ["cdn-cookieyes.com", "cdn.cookieyes.com", "cookieyes.com", "www.cookieyes.com"];

// CookieYes-Modus: CookieYes fragt selbst. GTM und Meta erst laden, wenn CookieYes die
// passende Kategorie meldet (beim Laden mit gespeicherter Wahl und bei jeder Änderung).
function cookieYesAnbinden() {
  once("_ygCyListen", () => {
    const pruefen = (accepted) => {
      const a = Array.isArray(accepted) ? accepted : [];
      if (a.includes("analytics")) injectStatistics({});
      if (a.includes("advertisement")) injectMarketing({});
    };
    document.addEventListener("cookieyes_consent_update", (e) => pruefen(e?.detail?.accepted));
    document.addEventListener("cookieyes_banner_load", () => {
      try {
        const c = window.getCkyConsent?.();
        if (c?.categories) pruefen(Object.keys(c.categories).filter((k) => c.categories[k]));
      } catch (_e) { /* ignore */ }
    });
  });
}

export function injectCookieYes(code) {
  cookieYesAnbinden();
  once("_ygCookieYes", () => {
    const m = code.match(/src=["']([^"']+)["']/i);
    if (!m) return;
    // Zweite Schranke zur Server-Validierung: nur CookieYes-Hosts dürfen Skripte liefern.
    let host = "";
    try { host = new URL(m[1], window.location.origin).hostname; } catch { return; }
    if (!CY_HOSTS.includes(host)) return;
    const s = document.createElement("script");
    const idm = code.match(/id=["']([^"']+)["']/i);
    if (idm) s.id = idm[1];
    s.src = m[1];
    document.head.appendChild(s);
  });
}
